module.exports = __webpack_public_path__ + "static/media/13.e5849548.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/13.png
// module id = 1254
// module chunks = 0